import { EpimsBaseEntityDto } from './epim-base.dto';
export class EngagementTypeDto extends EpimsBaseEntityDto {

    EngagementTypeId: string;

    EngagementTypeName: string;

   

}